module.exports = __webpack_public_path__ + "img/tree-04-b-trunk.af45ea8f.png";